import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { request } from "../utill";
import LoadingSpinner from "../components/LoadingSpinner";
import { toast } from "react-toastify";
import Success from "../components/success";
import localforage from "localforage";

const WarrantyForm = () => {
  const [codeWarranty, setCodeWarranty] = useState("");
  const [loading, setLoading] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const navigate = useNavigate();

  useEffect(()=>{
    localforage.getItem("jwt").then((jwt)=>{
      if(!jwt) navigate("/login")
    })
  }, [])

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      const response = await request(
        `/esalat-user/get-warranty?warranty=${codeWarranty}`,
        "GET"
      );

      if (response.status === "unauthorized") {
        await localforage.removeItem("jwt");
        toast.success("لطفا وارد شوید.", { rtl: true });
        return navigate("/login");
      }

      if (response.success && response.data) {
        setSuccessData(response.data);
      } else {
        toast.error(
          response.message || "مشکلی در دریافت اطلاعات گارانتی پیش آمده است.",
          { rtl: true }
        );
      }
    } catch (error) {
      toast.error("خطا در دریافت اطلاعات: " + error.message, { rtl: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout success={successData}>
      {successData ? (
        <Success data={successData} setSuccessData={setSuccessData} />
      ) : (
        <>
          <h1 className="login-title">ورود / ثبت نام</h1>
          <p className="login-text">کد گارانتی را وارد کنید</p>

          {loading && <LoadingSpinner />}

          <form onSubmit={handleSubmit}>
            <div className="AZ-field-group">
              <input
                type="text"
                value={codeWarranty}
                onChange={(e) => setCodeWarranty(e.target.value)}
              />
            </div>

            <div className="login-footer w-100">
              <button
                type="submit"
                className="AZ-primary-btn d-flex align-items-center justify-content-center w-100"
                disabled={loading}
              >
                {loading ? "در حال پردازش..." : "ثبت"}
              </button>
            </div>
          </form>
        </>
      )}
    </Layout>
  );
};

export default WarrantyForm;
